import "./AsyncLoadingAnimation.css";

export default function AsyncLoadingAnimation(props: {width?: string, height?: string, className?: string}): JSX.Element {
    return <div className={"AsyncLoadingAnimation " + props?.className} style={{width: props.width, height: props.height}}></div>
}